var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.copyrightNotice)?_c('div',{staticClass:"global-footer"},[_c('span',{staticClass:"d-block"},[_vm._v(" "+_vm._s(_vm.copyrightNotice)+" ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }